import URI from 'urijs'
import { env, Model } from '@polleverywhere/core'
import { bindings, platform as slidewarePlatform } from '@polleverywhere/slideware-bindings'
import isMobileApp from '../../util/is_mobile_app'

export function platform (nativePrefix = 'presenter_') {
  return isMobileApp()
    ? `${nativePrefix}${window.Capacitor.platform.toLowerCase()}`
    : 'web'
}

export function isIos () {
  return window.Capacitor && window.Capacitor.isNative && window.Capacitor.platform === 'ios'
}

export function openSSOPopover (url) {
  if (isMobileApp()) {
    // Let in app browser handle the link
    const options = isIos()
      ? 'location=no,closebuttoncaption=Cancel,clearcache=yes'
      : 'location=yes,clearcache=yes'

    openWithInAppBrowser(url, options)
  } else {
    // Navigate with current window and let it redirect back
    window.location.href = url
  }
}

export function openWithInAppBrowser (url, options) {
  if (isMobileApp()) {
    window.Capacitor.Plugins.Browser.open({ url })
  } else {
    window.ssoPopover = window.open(url, '_blank', options)
  }
}

export async function outOfBandLogin (finishedCallback, oauth2Redirect) {
  const outOfBandAuthenticationCode = new Model.OutOfBandAuthenticationCode()
  await outOfBandAuthenticationCode.save()

  outOfBandAuthenticationCode.on('completed', () => {
    finishedCallback()
  })

  outOfBandAuthenticationCode.on('failed', (error) => {
    throw new Error(error)
  })

  const authUrl = env.get('api_url')
    .path(outOfBandAuthenticationCode.url())
    .query({
      start_login: true,
      provider: oauth2Redirect.provider,
      saml_issuer: oauth2Redirect.samlIssuer
    })

  outOfBandAuthenticationCode.startChecking()
  return authUrl.toString()
}

function checkGoogPresenterLogin () {
  return Backbone.ajax({
    method: 'GET',
    url: env.get('api_url').path('/oauth2/session_check'),
    headers: {
      accept: 'application/json'
    }
  })
    .then(() => true)
    .catch(() => false)
}

export async function googPresenterLogin (finishedCallback, oauth2Redirect) {
  let sessionTimeoutId

  const pollforSession = () => {
    clearTimeout(sessionTimeoutId)

    sessionTimeoutId = setTimeout(() => {
      checkGoogPresenterLogin().then((done) => {
        if (done) {
          finishedCallback()
        } else {
          pollforSession()
        }
      })
    }, 2000)
  }

  await bindings.openBrowser({ url: oauth2Redirect.url })
  pollforSession()
}

export function environment (options) {
  if (options.role === 'embed') {
    return 'embed'
  }

  if (options.role === 'agave') {
    return 'agave'
  }

  if (isMobileApp()) {
    return 'mobile'
  }

  if (bindings && bindings.canOpenBrowser()) {
    if (slidewarePlatform() === 'google') {
      return 'chrome'
    } else {
      return 'desktop'
    }
  }

  return 'web'
}

function ssoRedirectLink (userRole) {
  if (isMobileApp()) {
    const path = userRole === 'participant' ? '/' : '/activities'
    return env.get('api_url').path(`/auth/redirect/${platform(`${userRole}_`)}`).query({ path })
  } else {
    return URI()
  }
}

export function appendParamsToSSOLink (link, userRole) {
  return URI(link)
    .query({
      redirect: ssoRedirectLink(userRole),
      token_required: isMobileApp()
    })
    .toString()
}
